import React from 'react';
import { Card, CardBody, Typography } from '@material-tailwind/react';
import { formatMoney } from '../../shared/formatMoney';

const MonthlyInvoicesHeader = ({ activeTab, monthlySettings, onChangeTab }) => (
  <Card className="border-0 shadow-md mb-6">
    <CardBody className="p-4">
      <div className="mb-4">
        <Typography variant="h6" className="font-semibold text-gray-800">
          Monthly Invoice Settings
        </Typography>
        {monthlySettings !== null && (
          <Typography className="text-gray-600 mt-2">
            Base Monthly Amount:{' '}
            <span className="font-semibold text-lg text-green-700">
              {formatMoney(monthlySettings)}
            </span>
            <br />
            <span className="text-sm text-gray-500">
              (Amount x Number of Active Cars, with proration for mid-month allocations)
            </span>
          </Typography>
        )}
      </div>

      <div className="flex border-b border-gray-200 mb-6 mt-6 pt-6 border-t">
        <button
          onClick={() => onChangeTab('create')}
          className={`px-6 py-3 font-semibold text-base transition-all border-b-2 ${activeTab === 'create'
            ? 'border-[#FF5733] text-[#FF5733]'
            : 'border-transparent text-gray-600 hover:text-gray-800'
            }`}
        >
          Create Invoice
        </button>
        <button
          onClick={() => onChangeTab('history')}
          className={`px-6 py-3 font-semibold text-base transition-all border-b-2 ${activeTab === 'history'
            ? 'border-[#FF5733] text-[#FF5733]'
            : 'border-transparent text-gray-600 hover:text-gray-800'
            }`}
        >
          Invoice History
        </button>
      </div>
    </CardBody>
  </Card>
);

export default MonthlyInvoicesHeader;
